import { useQuery } from "@tanstack/react-query";
import { ActionsTable } from "Common/Components";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DeleteOptionsMenuService, OptionsMenuService } from "services";
import { useOptionsMenus } from "../../store";
import { useTranslation } from "react-i18next";
import { OptionItemsI } from "interfaces";

export const useListOptions = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    isOpenModalOption,
    handleCloseModal,
    handleOpenModal,
    setIsEdit,
    isEdit,
    setOption,
  } = useOptionsMenus();
  const columns = [
    {
      header: 'ID',
      accessorKey: 'ID',
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: t('createOption.tablesColumn.description'),
      accessorKey: 'description',
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: t('createOption.tablesColumn.url'),
      accessorKey: 'url',
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: t('createOption.tablesColumn.menu'),
      accessorKey: 'menu',
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: t("createOption.form.viewApp"),
      accessorKey: 'viewapp',
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: t('createOption.tablesColumn.action'),
      accessorKey: 'actions',
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ getValue }: { getValue: () => any }) => getValue(),
    },
  ];
   const [optionsSRows, setOptionsRows] = useState<any[]>([]);

  const {
    data: dataOptionsMenu,
    error: errorOptionsMenu,
    isLoading: isLoadingOptionsMenu,
    refetch: refetchventsOptionsMenu,
    isFetching: isFetchingOptionsMenu,
  } = useQuery({
    queryKey: ['security-service-options-menus'],
    queryFn: OptionsMenuService,
    staleTime: 1000 * 60 * 60,
  });

  useEffect(() => {
    if (dataOptionsMenu) {
      setOptionsRows(createOptionsRows(dataOptionsMenu.data));
    }
  }, [dataOptionsMenu]);
  
    const createOptionsRows = (options: OptionItemsI[]) => {
      return options.map((option, index) => ({
        ID: index + 1,
        description: option.description,
        url: option.url,
        menu: option.mainmenu.description,
        viewapp: option.viewapp === 1 ? t('createOption.yes') : t('createOption.not'),
        actions: (
          <ActionsTable
            onClickDelete={() => onClickDelete(option.id)}
            onClickEdith={() => handleEdit(option)}
          ></ActionsTable>
        ),
      }));
    };
  const handleAddOption = useCallback(() => {
    if (isOpenModalOption) {
      handleCloseModal();
      setIsEdit(false);
    } else {
      handleOpenModal();
    }
  }, [isOpenModalOption]);
  // Delete Modal
  const [OptionData, setOptionData] = useState<number>(0);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  // Delete Data
  const onClickDelete = (id: number) => {
    setDeleteModal(true);
    if (id) {
      setOptionData(id);
    }
  };

  const handleDelete = async () => {
    const response = await DeleteOptionsMenuService(OptionData);
    if (response.code === "200") {
      refetchventsOptionsMenu();
      setDeleteModal(false);
      toast.success(t("createOption.DeleteMessage"), { autoClose: 2000 });
    } else {
      setDeleteModal(false);
      toast.error(t("createOption.ErrorMessage"), { autoClose: 2000 });
    }
  };

  const handleEdit = async (option: any) => {
    handleOpenModal();
    setIsEdit(true)
    setOption(option);
  };

  return {
    columns,
    navigate,
    optionsList: optionsSRows,
    handleAddOption,
    show: isOpenModalOption,
    isEdit,
    errorOptionsMenu,
    isLoadingOptionsMenu,
    refetchventsOptionsMenu,
    isFetchingOptionsMenu,
    deleteModal,
    handleDelete,
    deleteToggle,
  };
};
